import Body   from './Body';
import Filter from './Filter';
import Search from './Search';

export const Components = {
  Body,
  Filter,
  Search,
};
